import React from "react";
import ManageDefaultRoutes from "../../ManageDefaultRoutes";
import { Route } from "react-router-dom";
import Dashboard from "../../../pages/Financial/Accountent/Dashboard/Index";
import Liabilities from "../../../pages/Financial/Accountent/Liabilities/Index";
import Expences from "../../../pages/Financial/Accountent/Expenses/Index";
import Revenue from "../../../pages/Financial/Accountent/Revenue/Index";

const AccountentRoutes = (
  <>
    <Route path="accountent/*">
      <Route index element={<ManageDefaultRoutes path="dashboard" />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="liabilities" element={<Liabilities />} />
      <Route path="expenses" element={<Expences />} />
      <Route path="revenue" element={<Revenue />} />
    </Route>
  </>
);
export default AccountentRoutes;
